import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {CarrierContactInfo} from './carrier-contact-info';
import {CarrierContactInfoService} from 'src/app/services/carrier-contact-info/carrier-contact-info.service';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {CommonValidators} from 'src/app/shared/common-components/common-validators';

@Component({
    selector: 'app-carrier-contact-info',
    templateUrl: './carrier-contact-info.component.html',
    styleUrls: ['./carrier-contact-info.component.css'],
    standalone: false
})
export class CarrierContactInfoComponent implements OnInit {
  routeParamOrganizationId: number;
  routeParamCarrierId: number;
  routeParamBusinessType: any;
  routeParamScac: any;
  title: string;
  carrierContactInfoForm: UntypedFormGroup;
  carrierContactList: CarrierContactInfo[] = [];
  newRecord: CarrierContactInfo;
  saveContactType: string;
  hhgAndFrt = false;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private carrierContactInfoService: CarrierContactInfoService) {
  }

  ngOnInit() {
    this.routeParamOrganizationId = this.route.snapshot.queryParams['organizationId'];
    this.routeParamCarrierId = this.route.snapshot.queryParams['carrierId'];
    this.routeParamBusinessType = this.route.snapshot.queryParams['businessType'];
    this.routeParamScac = this.route.snapshot.queryParams['scac'];
    this.title = this.routeParamScac + ' Shipment Booking Contact Information for ' +
      this.routeParamBusinessType;
    this.getAllCarrierContacts(this.routeParamCarrierId);
    this.hhgAndFrt = this.routeParamBusinessType == 'HHG & FRT';
    this.createForm();
    if (!this.hhgAndFrt) {
      this.carrierContactInfoForm.get('options').clearValidators();
      this.saveContactType = this.routeParamBusinessType;
    }
  }

  goToCarrierProfile() {
    this.router.navigate(['/carrierprofile'], {
      queryParams: {
        orgId: [this.routeParamOrganizationId]

      }
    });
  }

  getAllCarrierContacts(carrierId: any) {
    this.carrierContactInfoService.getAllCarrierContacts(carrierId)
      .subscribe(carrierContacts => {
          this.carrierContactList = carrierContacts;
          this.loadForm();

        }, error => {
          console.log('error while retreving carrier contacts');
        }
      );
  }

  createForm() {
    this.carrierContactInfoForm = this.fb.group({
      carrierId: new UntypedFormControl(''),
      contactType: new UntypedFormControl(''),
      options: new UntypedFormControl('', [Validators.required]),
      firstName: new UntypedFormControl('', [Validators.required]),
      middleInitial: new UntypedFormControl(''),
      lastName: new UntypedFormControl('', [Validators.required]),
      phone: new UntypedFormControl('', [Validators.required, Validators.minLength(10), CommonValidators.numeric]),
      phoneExt: new UntypedFormControl(''),
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email]),
    });
  }

  loadForm() {
    if (this.hhgAndFrt) {
      this.resetForm();
    } else {
      this.populateKeyFieldsForm(this.carrierContactList[0]);
    }
  }

  populateKeyFieldsForm(contactInfo: any) {
    this.carrierContactInfoForm.controls['carrierId']
      .setValue(+this.routeParamCarrierId);
    this.carrierContactInfoForm.controls['contactType']
      .setValue(contactInfo.contactType);
    this.populateForm(contactInfo);
  }

  populateForm(contactInfo: any) {
    this.carrierContactInfoForm.controls['firstName']
      .setValue(contactInfo.firstName);
    this.carrierContactInfoForm.controls['middleInitial']
      .setValue(contactInfo.middleIntial);
    this.carrierContactInfoForm.controls['lastName']
      .setValue(contactInfo.lastName);
    this.carrierContactInfoForm.controls['phone']
      .setValue(contactInfo.phone);
    this.carrierContactInfoForm.controls['phoneExt']
      .setValue(contactInfo.phoneExt);
    this.carrierContactInfoForm.controls['email']
      .setValue(contactInfo.email);
  }

  resetForm() {
    this.carrierContactInfoForm.controls['carrierId'].setValue(+this.routeParamCarrierId);
    this.carrierContactInfoForm.controls['firstName'].setValue('');
    this.carrierContactInfoForm.controls['middleInitial'].setValue('');
    this.carrierContactInfoForm.controls['lastName'].setValue('');
    this.carrierContactInfoForm.controls['phone'].setValue('');
    this.carrierContactInfoForm.controls['phoneExt'].setValue('');
    this.carrierContactInfoForm.controls['email'].setValue('');
  }

  onContactTypeChg(contactType: any) {
    const contactInfo = this.carrierContactList.find(i => i.contactType == contactType);

    this.carrierContactInfoForm.controls['carrierId']
      .setValue(+this.routeParamCarrierId);
    this.saveContactType = contactType;
    let found = 0;
    let contactInfoToPopulate: any;
    this.carrierContactList.forEach(e => {
      if (e.contactType == contactType) {
        found = 1;
        contactInfoToPopulate = e;
      }
    });
    (found == 0) ? this.resetForm() : this.populateForm(contactInfoToPopulate);
  }

  saveContactInfo() {
    this.newRecord = new CarrierContactInfo();
    this.newRecord.carrierContactInfoId = 0;
    this.newRecord.carrierId = this.carrierContactInfoForm.get('carrierId').value;

    if (this.saveContactType == 'HHG') {
      this.newRecord.contactType = 'HHG';
    }
    if (this.saveContactType == 'FRT') {
      this.newRecord.contactType = 'FRT';
    }
    this.newRecord.firstName = this.carrierContactInfoForm.get('firstName').value;
    this.newRecord.middleIntial = this.carrierContactInfoForm.get('middleInitial').value;
    this.newRecord.lastName = this.carrierContactInfoForm.get('lastName').value;
    this.newRecord.phone = this.carrierContactInfoForm.get('phone').value;
    this.newRecord.phoneExt = this.carrierContactInfoForm.get('phoneExt').value;
    this.newRecord.email = this.carrierContactInfoForm.get('email').value;
    this.newRecord.updateDate = new Date();
    this.newRecord.updateProgram = '';
    this.newRecord.updateId = 0;
    this.tmssLoader.show();
    this.carrierContactInfoService.createupdateCarrierContact(this.newRecord)
      .subscribe(result => {
          this.alertService.success('Successfully saved TSP Contact Info');
          this.carrierContactInfoService.getAllCarrierContacts(this.newRecord.carrierId)
            .subscribe(carrierContacts => {
                this.carrierContactList = carrierContacts;
              },
              error => {
                console.log('error while retreving TSP contacts');
              }
            );
          this.tmssLoader.hide();
        },
        error => {
          console.log(error);
          this.alertService.error('error in updating TSP Contact');
          this.tmssLoader.hide();
        });
  }
}
